import React from "react";

const Stat_Mode = () => {
  return (
    <div>
      <h1>Stat Mode</h1>
    </div>
  );
};

export default Stat_Mode;
